import { render, staticRenderFns } from "./page-6.vue?vue&type=template&id=d4c99e80&scoped=true&"
import script from "./page-6.vue?vue&type=script&lang=js&"
export * from "./page-6.vue?vue&type=script&lang=js&"
import style0 from "./page-6.vue?vue&type=style&index=0&id=d4c99e80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c99e80",
  null
  
)

export default component.exports